export default __webpack_public_path__ + "static/The Backdrop_image 4@2x-f72816561c253142f23502d9097803fb.jpg";